module.exports = __webpack_public_path__ + "static/media/WhatWeDo_Meetups.4d159156.jpg";